import { Tab, Tabs } from "@mui/material";
import makeStyles from "../../makeStylesV4Compat";
import { useLocation } from "react-router-dom";
import { AssembleTag } from "src/components/AssembleTags/AssembleTag";
import { LinkTab } from "src/components/Layout/LinkTab";
import { PageHeader, PageTitle } from "src/components/Layout/PageHeader";
import { GRAY_1, GRAY_2, GRAY_4, WHITE } from "src/theme";

export const useStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    width: "100%",
    height: "100%",
    gap: theme.spacing(0.5),
  },
  tabBarContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  tabBar: {
    display: "flex",
    flexGrow: 1,
    minHeight: theme.spacing(4.4),
  },
  tabsContainer: {
    display: "flex",
    gap: theme.spacing(3),
  },
  tab: {
    color: GRAY_4,
    textDecoration: "none",
    "&:hover": {
      color: GRAY_1,
      opacity: 1,
    },
  },
  activeTab: {
    color: GRAY_1,
  },
  betaContainer: {
    alignItems: "center",
    display: "flex",
    marginLeft: theme.spacing(-1.5),
  },
  betaTag: {
    width: 36,
    background: GRAY_2,
    border: `1px solid ${GRAY_2}`,
    color: WHITE,
  },
}));

export function InsightsHeader(): JSX.Element | null {
  const location = useLocation();
  const classes = useStyles();

  const value = location.pathname.includes("bands")
    ? "bands"
    : location.pathname.includes("correction")
      ? "band-placement-correction"
      : "band-placement";

  return (
    <PageHeader>
      <div className={classes.header}>
        <PageTitle>Insights</PageTitle>
        {
          <div className={classes.tabBarContainer}>
            <Tabs
              value={value}
              className={classes.tabBar}
              classes={{ flexContainer: classes.tabsContainer }}
            >
              <Tab
                component={LinkTab}
                route="/insights/bands"
                title="Bands"
                classes={{
                  selected: classes.activeTab,
                  textColorInherit: classes.tab,
                }}
                value="bands"
              />
              <Tab
                component={LinkTab}
                route="/insights/band-placement"
                title="Salary Band Placement"
                classes={{
                  selected: classes.activeTab,
                  textColorInherit: classes.tab,
                }}
                value="band-placement"
              />
              <Tab
                component={LinkTab}
                route="/insights/band-placement-correction"
                title="Band Placement Correction"
                classes={{
                  selected: classes.activeTab,
                  textColorInherit: classes.tab,
                }}
                value="band-placement-correction"
              />
              <div className={classes.betaContainer}>
                <AssembleTag label="Beta" tagClassName={classes.betaTag} />
              </div>
            </Tabs>
          </div>
        }
      </div>
    </PageHeader>
  );
}
